/**
 * Vuex module for in-room message search
 * namespace: chat/MessageSearch
 */
const actions = {
  toggleOpen ({ commit }, open) {
    commit('TOGGLE_OPEN', open)
  },
  setQuery ({ commit }, query) {
    commit('SET_QUERY', query)
  },
  setResults ({ commit }, results) {
    commit('SET_RESULTS', results)
  },
  setLoading ({ commit }, loading) {
    commit('SET_LOADING', loading)
  },
  setError ({ commit }, error) {
    commit('SET_ERROR', error)
  },
  setSearched ({ commit }, searched) {
    commit('SET_SEARCHED', searched)
  },
  reset ({ commit }) {
    commit('SET_QUERY', '')
    commit('SET_RESULTS', [])
    commit('SET_LOADING', false)
    commit('SET_ERROR', null)
    commit('SET_SEARCHED', false)
  }
}

const mutations = {
  TOGGLE_OPEN (state, open) {
    state.open = open
  },
  SET_QUERY (state, query) {
    state.query = query
  },
  SET_RESULTS (state, results) {
    state.results = results
  },
  SET_LOADING (state, loading) {
    state.loading = loading
  },
  SET_ERROR (state, error) {
    state.error = error
  },
  SET_SEARCHED (state, searched) {
    state.searched = searched
  }
}

const state = {
  open: false,
  query: '',
  results: [],
  loading: false,
  error: null,
  searched: false
}

const getters = {
  open: state => state.open,
  query: state => state.query,
  results: state => state.results,
  loading: state => state.loading,
  error: state => state.error,
  searched: state => state.searched
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
